// This file is auto-generated by 'pnpm rebuild:icons'
import type { TemplateOnlyComponent } from '@ember/component/template-only';

import type { Signature } from './types.ts';

const IconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='5.1 5.32 246 245.38'
    ...attributes
  ><g stroke='var(--icon-color, #000)' stroke-width='10'><path
        d='M83.4 75.2 119.6 39v148.2c0 4.6 3.8 8.4 8.4 8.4s8.4-3.8 8.4-8.4V39l36.2 36.2c3.3 3.3 8.6 3.3 11.9 0 1.6-1.6 2.5-3.8 2.5-5.9s-.8-4.3-2.5-5.9L134 12.8a8.39 8.39 0 0 0-11.9 0L71.5 63.3c-3.3 3.3-3.3 8.6 0 11.9s8.6 3.3 11.9 0z'
      /><path
        d='M237.6 144.6c-4.6 0-8.4 3.8-8.4 8.4v67.4c0 4.6-3.8 8.4-8.4 8.4H35.3c-4.6 0-8.4-3.8-8.4-8.4V153c0-4.6-3.8-8.4-8.4-8.4s-8.4 3.8-8.4 8.4v67.4c0 13.9 11.3 25.3 25.3 25.3h185.4c13.9 0 25.3-11.3 25.3-25.3V153c-.1-4.6-3.9-8.4-8.5-8.4z'
      /></g></svg>
</template>;

// @ts-expect-error this is the only way to set a name on a Template Only Component currently
IconComponent.name = 'Upload';
export default IconComponent;
